import { render, staticRenderFns } from "./StartFinancialYear.vue?vue&type=template&id=584773d2&"
import script from "./StartFinancialYear.vue?vue&type=script&lang=js&"
export * from "./StartFinancialYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports